exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-input--selection-controls[data-v-520b0e2b]{margin-top:0!important}", ""]);

// exports
